module.exports = __webpack_public_path__ + "static/media/lemon-slice-3.051ba625.png";